// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoArea_container_2lOvH","title":"InfoArea_title_2Q_kP","description":"InfoArea_description_Unvmu"};